module.exports.Stargate_Proxy_Url =
    'https://gateway-stage-core.optum.com/api/dev/infra/cptt/cptt-service/v1/estimates';
module.exports.Cptt_Cookie = 'cptt-microfrontend';
module.exports.keyName = 'services';
module.exports.TIME_UNTIL_NEXT_CACHE_UPDATE = 1000 * 60 * 60 * 24;
module.exports.Cptt_Cookie_graphql = 'cptt-microfrontend-graphql';
module.exports.PERSON = 'Person';
module.exports.PLACE = 'Place';
